import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Header from 'modules/expenses/components/expenses/PageContents/_Header'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'

import { QuickFiltersProvider } from './QuickFiltersContext'

const Content = ({ children }: React.PropsWithChildren) => {
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useMyExpenses()

  return (
    <QuickFiltersProvider>
      <Box alignItems="center" justifyContent="center">
        <Box gap="s16" width="full">
          {!dataCollectionEnabled && (
            <Header title={i18n.t('expenses_v2.tabs.my_expenses')} filterType={'draft'} />
          )}
          {children}
        </Box>
      </Box>
    </QuickFiltersProvider>
  )
}

export default Content
